import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import AdminPage from '../pages/AdminPage'; 
import AdminUsers from '../pages/AdminUsers';
import ErrorPage from '../pages/ErrorPage';
import Loader from '../components/Loader';


interface Props {
  user: User | null;
  permissions: Permission[];
  loading: boolean;
}

const AdminRoutes: React.FC<Props> = ({ user, permissions, loading }) => {
  // Aqui você pode adicionar validações com base em permissões se quiser
  const isAuthenticated = !!user;
  const location = useLocation();

  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to={`/login?continue=${encodeURIComponent(location.pathname)}`} />;
  }

  if (!permissions.some(permission => permission.name === 'Administrador')) {
    return <ErrorPage code={403} />;
  }

  return (
    <Routes>
      <Route path="/" element={<AdminPage user={user} />} />
      <Route path="/accounts" element={<AdminUsers />} />

      {/* Rota fallback para páginas não encontradas */}
      <Route path="*" element={<ErrorPage code={404} />} />
    </Routes>
  );
};

export default AdminRoutes;
